<div class="popover-container">
  <ng-content></ng-content>
</div>